import React from 'react';
import { getAuth, signOut } from 'firebase/auth'
import {FaUserCircle } from "react-icons/fa"
import { currentUser } from '../../util/currentUser';
import { Link } from 'react-router-dom';

const BarTopClient = () => {

    //deconnecter l'utilisateur 
    const deconnecter = ()=>{
        const auth = getAuth();
        signOut(auth).then(() => {
        // Sign-out successful.
            alert('deconnecter')
        }).catch((error) => {
        // An error happened.
            alert(error)
        });
    }


    return (
        <div className='bg-light shadow'>
            <div className='row'>
                <div className='col-sm-6 col-md-3 ms-auto float-end '>
                    <div className="nav-item dropdown pt-3">
                        <p className="nav-lin dropdown-toggle navbar-profile-name"  href="#" id="navbarScrollingDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={currentUser.imgSrc} alt="" className=' rounded-circle border border-primary mx-3' style={{width:"40px", height:"40px"}}/>
                            {currentUser.userName}
                        </p>
                        <ul className="dropdown-menu "  aria-labelledby="navbarScrollingDropdown">
                                <p className="mx-3"><Link className=" btn btn-danger  " to="/Connexion" onClick={deconnecter}>Deconnexion</Link></p>                    
                        </ul>
                    </div>
                </div>  
            </div>
        </div>
    );
};

export default BarTopClient;